import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IGenericSelectDto } from '../../models/Interfaces';
import { CategoryLevelEnum } from '../../models/category.v2';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { CategoryV2Service } from '../../pages/members/category-v2/services/category.v2.service';
import { BrandService } from '../../pages/members/brand/services/brand.service';

@Component({
  selector: 'app-filters-modal',
  templateUrl: './filters-modal.component.html'
})
export class FiltersModalComponent {
  @Output() onSearch = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();
  @Output() onClear = new EventEmitter<void>();
    @Input() storeId: string = '';
    @Input() mode: 'default' | 'images' | 'precios' = 'default';
    @Input() branches: { name: string; branchId: string }[] = [];

    destroy$ = new Subject<any>();
    brandSearch$ = new Subject<string>();
    categorySearch$ = new Subject<string>();
  filterForm: FormGroup;
  categorySearchTerm = '';
  categoryPage = 1;
  hasMoreCategories = true;
  isLoadingMoreCategories = false;

  categories: IGenericSelectDto<string>[] = [];
  brands: IGenericSelectDto<string>[] = [];
  brandSearchTerm = '';
  brandPage = 1;
  hasMoreBrands = true;
  isLoadingMoreBrands = false;
  status = [
    { value: 'ACTIVE', key: 'Activo' },
    { value: 'INACTIVE', key: 'Inactivo' },
  ];
  constructor(
    private fb: FormBuilder,
    private readonly _categoryService: CategoryV2Service,
    private readonly _brandService: BrandService,) {
    this.filterForm = this.fb.group({
      q: [''],
      sku: [''],
      productId: [''],
      categoryId: [''],
      brandId: [''],
      status: [''],
      branchIds: [[]],   
    });
  }
  get branchOptions(): { key: string; value: string }[] {
    return this.branches.map(b => ({
      key: (b as any).label,
      value: (b as any).id
    }));
  }
  get branchMultiSelectList() {
    return this.branchOptions.map(b => ({
      id: b.value,
      name: b.key
    }));
  }
  onBranchesSelected(selected: any[]) {
  
    const ids = selected.map(s => s.id);
    this.filterForm.get('branchIds')?.setValue(ids);
  
    this.onChange.emit({
      branches: selected.map(s => ({ id: s.id, name: s.name }))
    });
  
  }
   ngOnInit() {
          this.initData();
  
          this.brandSearch$
              .pipe(debounceTime(800), takeUntil(this.destroy$))
              .subscribe(term => {
                  this.brandSearchTerm = term;
                  this.brandPage = 0;
                  this.hasMoreBrands = true;
  
                  this._brandService.list({
                      storeId: this.storeId,
                      page: 0,
                      size: 10,
                      name: term
                  })
                      .pipe(takeUntil(this.destroy$))
                      .subscribe(res => {
                          this.brands = res.items.map(x => ({
                              key: x.name,
                              value: x.id
                          }));
  
                          this.hasMoreBrands = this.brands.length < res.page.totalElements;
                      });
              });
  
  
          this.categorySearch$
              .pipe(debounceTime(400), takeUntil(this.destroy$))
              .subscribe(term => {
                  this.categorySearchTerm = term;
                  this.categoryPage = 0;
                  this.hasMoreCategories = true;
  
                  this._categoryService.list(this.storeId, {
                      size: 10,
                      page: 0,
                      name: term,
                      level: CategoryLevelEnum.LEAF
                  }).pipe(takeUntil(this.destroy$))
                      .subscribe(res => {
                          this.categories = res.items.map(x => ({
                              key: x.shortName,
                              value: x.id
                          }));
  
                          this.hasMoreCategories = this.categories.length < res.page.totalElements;
                      });
              });
  
      }

      initData() {
              this._categoryService.list(this.storeId, {
                  size: 10,
                  page: 0,
                  level: CategoryLevelEnum.LEAF
              })
                  .pipe(takeUntil(this.destroy$))
                  .subscribe({
                      next: (res) => {
                          this.categories = res.items.map(x => ({
                              key: x.shortName,
                              value: x.id
                          }))
                      }
                  })
      
              this._brandService.list({
                  storeId: this.storeId,
                  page: 0,
                  size: 10
              })
                  .pipe(takeUntil(this.destroy$))
                  .subscribe({
                      next: (res) => {
                          this.brands = res.items.map(x => ({
                              key: x.name,
                              value: x.id
                          }))
                      }
                  })
          }

          loadMoreCategories() {
            if (this.isLoadingMoreCategories || !this.hasMoreCategories) return;
    
            this.isLoadingMoreCategories = true;
    
            this._categoryService.list(this.storeId, {
                size: 10,
                page: this.categoryPage,
                name: this.categorySearchTerm,
                level: CategoryLevelEnum.LEAF
            })
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (res) => {
                        const newCategories = res.items.map(x => ({
                            key: x.shortName,
                            value: x.id
                        }));
    
                        this.categories = [...this.categories, ...newCategories];
    
                        const total = res.page.totalElements;
                        this.hasMoreCategories = this.categories.length < total;
                        if (this.hasMoreCategories) {
                            this.categoryPage++;
                        }
    
                        this.isLoadingMoreCategories = false;
                    },
                    error: () => {
                        this.isLoadingMoreCategories = false;
                    }
                });
        }
        loadMoreBrands() {
          if (this.isLoadingMoreBrands || !this.hasMoreBrands) return;
  
          this.isLoadingMoreBrands = true;
  
          this._brandService.list({
              storeId: this.storeId,
              page: this.brandPage,
              size: 10,
              name: this.brandSearchTerm
          })
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                  next: (res) => {
                      const newBrands = res.items.map(x => ({
                          key: x.name,
                          value: x.id
                      }));
  
                      this.brands = [...this.brands, ...newBrands];
  
                      const total = res.page.totalElements;
                      this.hasMoreBrands = this.brands.length < total;
  
                      if (this.hasMoreBrands) {
                          this.brandPage++;
                      }
  
                      this.isLoadingMoreBrands = false;
                  },
                  error: () => {
                      this.isLoadingMoreBrands = false;
                  }
              });
      }
  onCategorySelect(event: IGenericSelectDto<string> | null) {
    this.filterForm.get('categoryId')?.setValue(event?.value ?? null);
  }
  
  onBrandSelect(event: IGenericSelectDto<string> | null) {
    this.filterForm.get('brandId')?.setValue(event?.value ?? null);
  }
  
  
  onStatusSelect(event: IGenericSelectDto<string> | null) {
    this.filterForm.get('status')?.setValue(event?.value ?? null);
  }
  
  handleSearch() {
    const values = this.filterForm.value;

    const filters: any = {};
    if (values.q) filters.q = values.q;
    if (values.sku) filters.skuIds = [values.sku];
    if (values.categoryId) filters.categoryId = values.categoryId;
    if (values.brandId) filters.brandId = values.brandId;
    if (values.status) filters.status = values.status;
    if (this.mode === 'images' && values.productId) {
    filters.productIds = [values.productId];
  }
  if (this.mode === 'precios') {
    if (values.branchIds?.length) filters.branchIds = values.branchIds;
  }

    this.onSearch.emit(filters);
  }

  handleClear() {
    this.filterForm.reset();
    this.onClear.emit();
  }
}
